module.exports = __webpack_public_path__ + "static/HEITECH-35b98574a0568a9a8a616c8206a65aab.png";